import React, { Component } from 'react';
import { Box } from '@rebass/grid';
import styled from 'styled-components';
import { Button } from 'freemium-ui';

const BoxContainer = styled(Box)`
  min-width: 20%;
`;

type FormikResetProps = {
  formProp?: any,
  children?: React.ReactNode | string
};

class FormikReset extends Component<FormikResetProps> {
  static defaultProps = {
    formProp: {},
    children: 'Reset'
  };

  resetForm = ({ initialValues, resetForm, setValues }) => () => {
    resetForm();
    setValues(initialValues);
  };

  render() {
    const {
      formProp: { initialValues, dirty, resetForm, setValues, isSubmitting },
      children
    } = this.props;

    if (!isSubmitting) {
      return (
        <BoxContainer width="auto" ml={2}>
          <Button
            type="secondary"
            onClick={this.resetForm({
              initialValues,
              resetForm,
              setValues
            })}
            disabled={!dirty}
          >
            {children}
          </Button>
        </BoxContainer>
      );
    }
    return null;
  }
}
export default FormikReset;
